<template>
  <div v-if="isDescShow" class="channel-top-bar flex-row">
    <div class="channel-top-bar-title">
      <span class="channel-top-bar-brand">{{ descTitlePrefix }}</span>
      <span class="channel-top-bar-focus">{{ descTitleSuffix }}</span>
    </div>
    <div class="channel-top-bar-divider"></div>
    <span class="channel-top-bar-desc" v-html="description"></span>
    <div class="channel-top-bar-contact flex-row">
      <img
        class="channel-top-bar-phone-icon"
        referrerpolicy="no-referrer"
        :src="require('./img/phone-icon.png')"
      />
      <span class="channel-top-bar-phone-text">
        联系方式
        <br />
        {{ contactPhone || '' }}
      </span>
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'ChannelTopBar',
  data() {
    return {
      isDescShow: 1,
      descTitle: '',
      description: '',
      contactPhone: '',
      seoKeywords: '',
      seoDescription: '',
      seoTitle: '',
    }
  }, 
  metaInfo() {
    return this.getMetaInfo
  },
  computed: {
    getMetaInfo() {
      return {
        title: this.seoTitle || '中国品牌网 - 国家市场监督管理总局 中国品牌杂志社主办',
        meta: [
          {
            name: 'keywords',
            content: this.seoKeywords || ''
          },
          {
            name: 'description',
            content: this.seoDescription || ''
          }
        ]
      }
    },
    descTitlePrefix() {
      if (this.descTitle && this.descTitle.length === 4) {
        return this.descTitle.slice(0, 2)
      }
      return this.descTitle || '中品'
    },
    descTitleSuffix() {
      if (this.descTitle && this.descTitle.length === 4) {
        return this.descTitle.slice(2)
      }
      return '聚焦'
    }
  },
  created() {
    this.loadInfo()
  },
  methods: {
    async loadInfo() {
      const categoryId = this.$route.query.categoryId
      if (!categoryId) return
      try {
        const res = await request.post('/api/category/getInfo', { id: categoryId })
        if (res.code === 200 && res.data) {
          this.isDescShow = res.data.isDescShow === 0 ? 0 : 1
          this.descTitle = res.data.descTitle || ''
          this.description = (res.data.description || '').replace(/\n/g, '<br>')
          this.contactPhone = res.data.contactPhone || ''
        }
      } catch (e) {
        console.error('频道信息加载失败', e)
      }
    }
  }
}
</script>

<style scoped>
/* 顶部横幅容器 */
.channel-top-bar {
  width: 1400px;
  height: 86px;
  background: #F5F5F7;
  border-radius: 0;
  margin: 26px auto 0;
}

/* 中品聚焦标题 */
.channel-top-bar-title {
  width: 80px;
  height: 30px;
  font-size: 0;
  font-family: 'Source Han Sans CN', 'Source Han Sans CN', sans-serif;
  font-weight: bold;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin: 32px 0 0 24px;
  flex-shrink: 0;
}

/* 中品 */
.channel-top-bar-brand {
  color: #C00513;
  font-family: inherit;
  font-weight: bold;
  font-size: 20px;
}

/* 聚焦 */
.channel-top-bar-focus {
  color: #000000;
  font-family: inherit;
  font-weight: bold;
  font-size: 20px;
}

/* 竖线分隔 */
.channel-top-bar-divider {
  width: 2px;
  height: 57px;
  background: #D8D8D8;
  border-radius: 0;
  margin-left: 26px;
  flex-shrink: 0;
  margin-top: 14.5px;
}

/* 描述文本 */
.channel-top-bar-desc {
  display: inline-flex;
  align-items: center;
  width: calc(873px - 50px); /* 减去左边距 */
  margin-left: 25px; /* 距离左边 25px */
  font-family: 'Microsoft YaHei', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #666666;
  line-height: 1.6;
  overflow: hidden;
  text-align: left;
  flex-shrink: 0;
}

/* 多行文字限制：最多显示两行 */
.channel-top-bar-desc::before {
  content: '';
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 联系电话区域 */
.channel-top-bar-contact {
  width: 321px;
  height: 86px;
  background: #E0E0E4;
  border-radius: 0;
  justify-content: space-between;
  margin: 0 -1px 0 100px;
  flex-shrink: 0;
}

/* 电话图标 */
.channel-top-bar-phone-icon {
  width: 44px;
  height: 45px;
  margin: 19px 0 0 65px;
  flex-shrink: 0;
}

/* 联系电话文字 */
.channel-top-bar-phone-text {
  width: 125px;
  height: 48px;
  font-family: 'Microsoft YaHei', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 24px;
  margin: 18px 65px 0 0;
  white-space: nowrap;
}
</style>
